/**
 * AOS + FsLightbox refresh (레이아웃에서 전역 로드)
 */
export class HomeAosLightbox {
    static init(): void {
        const w = window as unknown as {
            AOS?: { init: (opts?: object) => void };
            refreshFsLightbox?: () => void;
        };
        if (w.AOS && typeof w.AOS.init === "function") {
            w.AOS.init();
        }
        if (typeof w.refreshFsLightbox === "function") {
            w.refreshFsLightbox();
        }
    }
}
